/**
 * O servidor derrubou a conexão porque a conta perdeu o acesso à fase de testes
 * (aviso 147, techspec-landing-fase §03.3). O mundo avisa; a sessão, que não conhece
 * o mundo, escuta e volta para a tela de entrada com o motivo.
 */
const EVENTO = 'uoidle:acesso-encerrado';

export function avisarAcessoEncerrado(): void {
  window.dispatchEvent(new Event(EVENTO));
}

export function aoEncerrarAcesso(fn: () => void): () => void {
  window.addEventListener(EVENTO, fn);
  return () => window.removeEventListener(EVENTO, fn);
}
